module.exports = __webpack_public_path__ + "static/media/Bhaisi song (1).ae8eed3e.m4a";